import React from 'react';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="xl-header">
      <div className="xl-header-inner">
        <h1 className="xl-logo">杭州序列深维科技有限公司</h1>
        <div className="xl-header-actions">
          <nav className="xl-nav">
            <ul>
              <li><a href="/">主页</a></li>
              <li><a href="/products">产品介绍</a></li>
              <li><a href="/about">公司介绍</a></li>
              <li><a href="/contact">联系我们</a></li>
              <li><a href="/join">加入我们</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
